import { useQuery } from "@tanstack/react-query";

import * as Api from "./disruptions";
import { GetDisruptionsRequest } from '@/common/constants/map-display-types';

export function useGetDisruptions(request: GetDisruptionsRequest){
  const result = useQuery<ReturnTypePromise<typeof Api.getDisruptions>, Error>(
    ['disruptions', request],
    () => Api.getDisruptions(request),
    {
      useErrorBoundary: false,
    }
  );

  return {...result, data: result.data};
}
